import { Injectable } from '@angular/core';
import { SetImportFilesListConfig } from '@app/routes/index/pending-drawings/index/files/_actions';
import { ImportFilesFilters } from '@app/routes/index/pending-drawings/index/files/_models';
import { ROWS_PER_PAGE_OPTIONS } from '@app/shared/common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export const CURRENT_IMPORT_FILES_LIST_VERSION = 1;

interface ImportFilesListStateModel {
  version: number;
  itemsPerPage: number;
  filters?: ImportFilesFilters;
}

export const IMPORT_FILES_LIST_STATE_DEFAULTS: ImportFilesListStateModel = {
  version: CURRENT_IMPORT_FILES_LIST_VERSION,
  itemsPerPage: ROWS_PER_PAGE_OPTIONS[0],
};

@State<ImportFilesListStateModel>({
  name: 'ImportFilesList',
  defaults: IMPORT_FILES_LIST_STATE_DEFAULTS,
})
@Injectable()
export class ImportFilesListState {
  @Selector()
  static itemsPerPage(state: ImportFilesListStateModel): number {
    return state.itemsPerPage;
  }

  @Selector()
  static filters(state: ImportFilesListStateModel): ImportFilesFilters | undefined {
    return state.filters;
  }

  @Action(SetImportFilesListConfig)
  setListConfig(ctx: StateContext<ImportFilesListStateModel>, action: SetImportFilesListConfig) {
    ctx.patchState({
      itemsPerPage: action.config.pagination.itemsPerPage as number,
      filters: {
        fileNames: action.config.fileNames ?? undefined,
        importedAtFrom: action.config.importedAtFrom ?? undefined,
        importedAtTo: action.config.importedAtTo ?? undefined,
        showPostedFiles: action.config.showPostedFiles || undefined,
      },
    });
  }
}
